<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="mx-auto" max-width="350"  :color="colorFondoDialog" outlined :style="'border: 5px solid grey;'">
          <v-card-text>
            <v-row class="my-4" >
              <v-img src="../assets/logo3.png" contain max-height="150" min-height="150">
              </v-img>
            </v-row>
            <v-text-field v-model="name" class="mx-4 mt-12" label="Nombre" name="name" type="text" outlined dense
              background-color="white" autocomplete="off">
            </v-text-field>

            <v-text-field id="password" v-model="password" class="mx-4" background-color="white" label="Contraseña"
              name="Contraseña" outlined dense type="password" @keydown.enter="_login">
            </v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-chip label class="mb-4 px-10" link :color="colorAccent1" @click="_login">
              <span v-if="loading" v-bind:style="{ color: 'white' }">
                Accediendo...
              </span>
              <span v-else v-bind:style="{ color: 'white' }">Acceder</span>
            </v-chip>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <h3> Version 0.9.5 </h3>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data: () => ({
    show: false,
    name: "",
    password: "",
  }),

  computed: {
    ...mapState([
      "loading",
      "colorFondoDialog",
      "colorBarraFormulario",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },

  mounted() {
   /* this.name = 'admin';
    this.password = 'abc1234';*/
    this._logout();
  },

  methods: {
    ...mapActions("auth", ["login", "logOut"]),
    ...mapMutations(["setDrawer"]),

    async _login() {
      await this.login([this.name, this.password]);
      console.log('user:', this.user);
      if (!this.error && this.user != null) {
        this.setDrawer(true);
        this.$router.push("/Reservas");
      }
    },

    async _logout() {
      await this.logOut([this.access_token]);
    },
  },
};
</script>

<style scoped>
.bottom-gradient {
  background-image: linear-gradient(to top,
      rgba(33, 34, 38, 1) 0%,
      transparent 80px);
}
</style>
